module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/extension-worker/extension-worker.06a73eb85e00c266b6d7.js");
};